import PropTypes from "prop-types";
import classNames from "classnames";

const IconSettings = ({ className, height = "24px", width = "24px" }) => {
    const classes = classNames("settingsIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            focusable="false"
            aria-hidden="true"
        >
            <path d="M23.72,10.67a1.06,1.06,0,0,0-.74-.34l-2-.09a9.15,9.15,0,0,0-1-2.69L21.48,6.2a1.06,1.06,0,0,0,.06-1.5L20.08,3.11A1.06,1.06,0,0,0,18.59,3L17.12,4.4a9.15,9.15,0,0,0-2.6-1.21l.09-2a1.06,1.06,0,0,0-1-1.1L11.43,0a1.06,1.06,0,0,0-1.1,1l-.09,2A9.12,9.12,0,0,0,7.55,4L6.2,2.52a1.06,1.06,0,0,0-1.5-.06L3.11,3.92a1.06,1.06,0,0,0-.06,1.5L4.4,6.88a9.18,9.18,0,0,0-1.21,2.6l-2-.09a1.06,1.06,0,0,0-1.1,1L0,12.57a1.06,1.06,0,0,0,1,1.1l2,.09a9.15,9.15,0,0,0,1,2.69L2.52,17.8a1.06,1.06,0,0,0-.06,1.5l1.46,1.59a1.06,1.06,0,0,0,1.5.06L6.88,19.6a9.17,9.17,0,0,0,2.6,1.21l-.09,2a1.06,1.06,0,0,0,1,1.1l2.16.09h0a1.06,1.06,0,0,0,1.06-1l.08-2a9.16,9.16,0,0,0,2.69-1l1.35,1.47a1.06,1.06,0,0,0,1.5.06l1.59-1.46a1.06,1.06,0,0,0,.06-1.5L19.6,17.12a9.13,9.13,0,0,0,1.21-2.6l2,.09a1.06,1.06,0,0,0,1.1-1L24,11.43A1.06,1.06,0,0,0,23.72,10.67ZM11.79,16.94A4.94,4.94,0,0,1,12,7.06h.22a4.94,4.94,0,1,1-.42,9.87Z" />
        </svg>
    );
};

IconSettings.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconSettings;
